import 'simplebar/dist/simplebar.min.css'

import { library } from '@fortawesome/fontawesome-svg-core'

import * as icons from './icons'

library.add(icons)
